import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Resources from "@/pages/Resources";
import SuccessStories from "@/pages/SuccessStories";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import ScrollToTop from "@/components/site/ScrollToTop";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-ivory">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D1B34",
            color: "#F7F5F1",
            border: "1px solid rgba(247,245,241,0.1)",
            fontFamily: "Lato, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
